module.exports = __webpack_public_path__ + "static/practice-portuguese-bg-e00311f6df01f9e2ef44a8773d6cc55b.jpg";